export interface ResearchParams {
  projectId: string
}

const endpoints = {
  productLineup: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/product_lineup/`
  },
  contentDistributionChannels: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/content_distribution_channels/`
  },
  competitorArchetypes: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_archetypes/`
  },
  competitorBenefits: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_benefits/`
  },
  competitorCreatives: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_creatives/`
  },
  competitorsStatistics: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/competitors/statistics/`
  },
  competitorMeanings: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_meanings/`
  },
  competitorMotives: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_motives/`
  },
  competitorPains: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_pains/`
  },
  competitorPositioningAnalysis: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_positioning_analysis/`
  },
  competitorValueProposition: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_value_proposition/`
  },
  competitorPromocodes: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_promocodes/`
  },
  competitorPromotions: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/competitor_promotions/`
  },
  contentFormats: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/content_formats/`
  },
  loyaltyPrograms: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/loyalty_programs/`
  },
  marketInnovations: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/market_innovations/`
  },
  missionVisionValues: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/mission_vision_values/`
  },
  socialMediaPositioningAudit: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/social_media_positioning_audit/`
  },
  socialMediaAudienceUnderstandingAudit: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/social_media_audience_understanding_audit/`
  },
  socialMediaValuePropositionAudit: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/social_media_value_proposition_audit/`
  },
  socialMediaTrustLayerAudit: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/social_media_trust_layer_audit/`
  },
  socialMediaToneOfVoiceAudit: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/social_media_tone_of_voice_audit/`
  },
  socialMediaCommunicationStrategyAudit: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/social_media_communication_strategy_audit/`
  },
  socialMediaCommunicationClarityAudit: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/social_media_communication_clarity_audit/`
  },
  socialMediaCommunicationConsistencyAudit: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/social_media_communication_consistency_audit/`
  },
  socialMediaCommunicationFunnelAudit: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/social_media_communication_funnel_audit/`
  },
  socialMediaObjectionHandlingAudit: ({ projectId }: ResearchParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/research/insights/social_media_objection_handling_audit/`
  },
}

export default endpoints
